import List from './CourseList'
import Create from './CreateCourse'
import Details from './CourseDetails'
import Enroll from './EnrollCourse'
import NewExam from './NewExamForm'


const exportObj = {
    Create,
    Details,
    Enroll,
    List,
    NewExam
}

export default exportObj